import reducerRegistry from '@comeon/reducer-registry';
import FreeToPlayApiClient from './api/free-to-play-api-client';
import * as Types from './api/free-to-play-types';
import selectFreeToPlayState from './free-to-play-state-selector';
import { THUNDERBITE } from './constants';
import { LOGIN_SUCCESS, LOGOUT } from '@comeon/actions-public';
import imageFormatHandler from '../utilities/image-format';
// import f2pConfigMockData from './mock-f2pConfig.json';
// import mockedCampaigns from './mock-banner-items.json';

const ACTION_PREFIX = '@komigen/free-to-play';
const REDUCER_NAME = 'free-to-play';
const SUCCESS = 'SUCCESS';

// Actions
const FETCH_FREE_TO_PLAY_CAMPAIGNS_LOADING = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_CAMPAIGNS_LOADING`;
const FETCH_FREE_TO_PLAY_CAMPAIGNS_SUCCESS = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_CAMPAIGNS_SUCCESS`;
const FETCH_FREE_TO_PLAY_CAMPAIGNS_ERROR = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_CAMPAIGNS_ERROR`;
const FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_LOADING = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_LOADING`;
const FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_SUCCESS = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_SUCCESS`;
const FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_ERROR = `${ACTION_PREFIX}/FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_ERROR`;
const SELECTED_CAMPAIGN_CLEAN_UP = `${ACTION_PREFIX}/SELECTED_CAMPAIGN_CLEAN_UP`;
const FETCH_F2P_CONFIG_LOADING = `${ACTION_PREFIX}/FETCH_F2P_CONFIG_LOADING`;
const FETCH_F2P_CONFIG_SUCCESS = `${ACTION_PREFIX}/FETCH_F2P_CONFIG_SUCCESS`;
const FETCH_F2P_CONFIG_ERROR = `${ACTION_PREFIX}/FETCH_F2P_CONFIG_ERROR`;

// Free to play campaigns
export const selectFreeToPlayCampaigns = (state: Types.RootState) => selectFreeToPlayState(state).campaigns;
export const selectFreeToPlayIsLoadingCampaigns = (state: Types.RootState) =>
	selectFreeToPlayState(state).isLoadingCampaigns;
export const selectFreeToPlayCampaignsHydrated = (state: Types.RootState) =>
	selectFreeToPlayState(state).campaignsHydrated;
export const selectFreeToPlayCampaignsError = (state: Types.RootState) => selectFreeToPlayState(state).campaignsError;

// Free to play selected campaign
export const selectFreeToPlaySelectedCampaign = (state: Types.RootState) =>
	selectFreeToPlayState(state).selectedCampaign;
export const selectFreeToPlaySelectedCampaignUrl = (state: Types.RootState) =>
	selectFreeToPlayState(state).selectedCampaign.selectedCampaignUrl;
export const selectFreeToPlayIsLoadingSelectedCampaign = (state: Types.RootState) =>
	selectFreeToPlayState(state).selectedCampaign.isLoadingSelectedCampaign;
export const selectFreeToPlaySelectedCampaignHydrated = (state: Types.RootState) =>
	selectFreeToPlayState(state).selectedCampaign.selectedCampaignHydrated;
export const selectFreeToPlaySelectedCampaignError = (state: Types.RootState) =>
	selectFreeToPlayState(state).selectedCampaign.selectedCampaignError;

// Free to play BO configuration
export const selectFreeToPlayConfiguration = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfiguration;
export const selectFreeToPlayConfigurationMainPanel = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfiguration.mainPanel;
export const selectFreeToPlayConfigurationRightPanel = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfiguration.rightPanel;
export const selectFreeToPlayConfigurationBottomPanel = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfiguration.bottomPanel;
export const selectFreeToPlayConfigurationHydrated = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfigurationHydrated;
export const selectFreeToPlayConfigurationError = (state: Types.RootState) =>
	selectFreeToPlayState(state).freeToPlayConfigurationError;

export const fetchCampaigns =
	(preferredProduct: string): Types.ThunkAction =>
	async (dispatch, _getState, { imageDescriptors, imageFormats }) => {
		dispatch({ type: FETCH_FREE_TO_PLAY_CAMPAIGNS_LOADING });
		try {
			const { status, result } = await FreeToPlayApiClient.fetchCampaigns(preferredProduct);
			if (status === SUCCESS) {
				const formatedResult = imageFormatHandler({ imageDescriptors, imageFormats })(result);
				return dispatch({ type: FETCH_FREE_TO_PLAY_CAMPAIGNS_SUCCESS, payload: formatedResult });
			}
			return dispatch({ type: FETCH_FREE_TO_PLAY_CAMPAIGNS_ERROR });
		} catch (error) {
			console.error(error);
			return dispatch({ type: FETCH_FREE_TO_PLAY_CAMPAIGNS_ERROR });
		}
		// return dispatch({ type: FETCH_FREE_TO_PLAY_CAMPAIGNS_SUCCESS, payload: mockedCampaigns });
	};

export const fetchSelectedCampaign =
	(id: string, type: string): Types.ThunkAction =>
	async dispatch => {
		dispatch({ type: FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_LOADING });
		try {
			const { status, result } = await FreeToPlayApiClient.fetchCampaignById(id, type);
			const url =
				type === THUNDERBITE
					? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
					  `${result?.url}${result?.campaign}?token=${result?.token}&vertical=v0`
					: result?.url;
			if (status === SUCCESS) {
				return dispatch({
					type: FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_SUCCESS,
					payload: {
						url
					}
				});
			}
			return dispatch({ type: FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_ERROR });
		} catch (error) {
			console.error(error);
			return dispatch({ type: FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_ERROR });
		}
	};

export const selectedCampaignCleanUp = (): Types.ThunkAction => dispatch => {
	dispatch({ type: SELECTED_CAMPAIGN_CLEAN_UP });
};

export const onCloseHandler = (): Types.ThunkAction => dispatch => {
	dispatch({ type: SELECTED_CAMPAIGN_CLEAN_UP });
};

export const fetchFreeToPlayConfiguration =
	(preferredProduct: string | null | undefined): Types.ThunkAction =>
	async dispatch => {
		dispatch({ type: FETCH_F2P_CONFIG_LOADING });
		try {
			const { status, result } = await FreeToPlayApiClient.fetchF2PConfig(preferredProduct);
			if (status === SUCCESS) {
				return dispatch({
					type: FETCH_F2P_CONFIG_SUCCESS,
					payload: result
				});
			}
			return dispatch({
				type: FETCH_F2P_CONFIG_ERROR
			});
		} catch (error) {
			console.error(error);
			return dispatch({
				type: FETCH_F2P_CONFIG_ERROR
			});
		}

		// return dispatch({
		// 	type: FETCH_F2P_CONFIG_SUCCESS,
		// 	payload: f2pConfigMockData
		// });
	};

const initialState: Types.FreeToPlayReducerState = {
	campaigns: [],
	isLoadingCampaigns: false,
	campaignsHydrated: false,
	campaignsError: false,
	freeToPlayConfigurationLoading: false,
	freeToPlayConfigurationHydrated: false,
	freeToPlayConfiguration: {
		mainPanel: '',
		rightPanel: '',
		bottomPanel: ''
	},
	freeToPlayConfigurationError: false,
	selectedCampaign: {
		selectedCampaignUrl: '',
		isLoadingSelectedCampaign: false,
		selectedCampaignHydrated: false,
		selectedCampaignError: false
	}
};

export type FreeToPlayDuckPayload = Types.CampaignItemById | Types.Campaigns | Types.F2PConfig;

const reducer = (
	state = initialState, // eslint-disable-line @typescript-eslint/default-param-last
	{
		type = '',
		payload
	}: // payload
	{
		type: string;
		payload: FreeToPlayDuckPayload;
	}
) => {
	switch (type) {
		case FETCH_FREE_TO_PLAY_CAMPAIGNS_LOADING:
			return {
				...state,
				isLoadingCampaigns: true
			};
		case FETCH_FREE_TO_PLAY_CAMPAIGNS_SUCCESS:
			const campaignsPayload = payload as Types.Campaigns; // eslint-disable-line
			return {
				...state,
				isLoadingCampaigns: false,
				campaignsHydrated: true,
				campaignsError: false,
				campaigns: campaignsPayload
			};
		case FETCH_FREE_TO_PLAY_CAMPAIGNS_ERROR:
			return {
				...state,
				campaignsError: true,
				isLoadingCampaigns: false
			};
		case FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_LOADING:
			return {
				...state,
				selectedCampaign: {
					...state.selectedCampaign,
					isLoadingSelectedCampaign: true
				}
			};
		case FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_SUCCESS:
			const selectedCampaignPayload = payload as Types.CampaignItemById; // eslint-disable-line
			return {
				...state,
				selectedCampaign: {
					...state.selectedCampaign,
					selectedCampaignUrl: selectedCampaignPayload.url,
					selectedCampaignHydrated: true,
					isLoadingSelectedCampaign: false,
					selectedCampaignError: false
				}
			};
		case FETCH_FREE_TO_PLAY_SELECTED_CAMPAIGN_ERROR:
			return {
				...state,
				selectedCampaign: {
					...state.selectedCampaign,
					isLoadingSelectedCampaign: false,
					selectedCampaignError: true
				}
			};
		case SELECTED_CAMPAIGN_CLEAN_UP:
			return {
				...state,
				selectedCampaign: {
					...state.selectedCampaign,
					selectedCampaignUrl: '',
					selectedCampaignHydrated: true,
					isLoadingSelectedCampaign: false,
					selectedCampaignError: false
				}
			};
		case FETCH_F2P_CONFIG_LOADING:
			return {
				...state,
				freeToPlayConfigurationLoading: true,
				freeToPlayConfigurationHydrated: false
			};
		case FETCH_F2P_CONFIG_SUCCESS:
			const f2pCongifPayload = payload as Types.F2PConfig; // eslint-disable-line
			return {
				...state,
				freeToPlayConfiguration: {
					mainPanel: f2pCongifPayload.mainPanel,
					rightPanel: f2pCongifPayload.rightPanel,
					bottomPanel: f2pCongifPayload.bottomPanel
				},
				freeToPlayConfigurationLoading: false,
				freeToPlayConfigurationHydrated: true
			};
		case FETCH_F2P_CONFIG_ERROR:
			return {
				...state,
				freeToPlayConfigurationLoading: false,
				freeToPlayConfigurationHydrated: true,
				freeToPlayConfigurationError: true
			};
		case LOGIN_SUCCESS:
			return {
				...state,
				freeToPlayConfigurationHydrated: false
			};
		case LOGOUT:
			return {
				...state,
				campaigns: [],
				campaignsHydrated: false,
				freeToPlayConfiguration: {
					mainPanel: '',
					rightPanel: '',
					bottomPanel: ''
				},
				freeToPlayConfigurationHydrated: false
			};
		default:
			return state;
	}
};

reducerRegistry.register(REDUCER_NAME, reducer);
export type State = ReturnType<typeof reducer>;
export default reducer;
